import React from 'react';
import { X } from 'lucide-react';
export function NotForYouSection() {
  return <section className="w-full bg-text py-20 px-6 md:px-8 text-cream" data-id="element-191">
      <div className="max-w-3xl mx-auto" data-id="element-192">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 text-center" data-id="element-193">
          Para quién NO es
        </h2>

        <div className="space-y-6 mb-12" data-id="element-194">
          {['Si buscas un manual médico o diagnóstico.', "Si quieres promesas tipo 'tu bebé dormirá toda la noche'.", 'Si estás buscando perfección.'].map((item, idx) => <div key={idx} className="flex items-center gap-4 bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-195">
              <X className="w-6 h-6 text-rose-DEFAULT flex-shrink-0" data-id="element-196" />
              <span className="text-lg text-cream-light" data-id="element-197">{item}</span>
            </div>)}
        </div>

        <p className="text-center text-2xl font-serif italic text-white/90" data-id="element-198">
          "Este plan es para la vida real."
        </p>
      </div>
    </section>;
}